import { 
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_SUCCESS_RESET,
  SET_SUSPENDED_USER_FLAG
} from "redux/constants/portal";

const initialState = {
  userLogoutSuccess: false,
  isSuspendedUser: false,
};

const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_LOGOUT_SUCCESS:
      return {
        ...state,
        userLogoutSuccess: true
      };
    case USER_LOGOUT_SUCCESS_RESET:
      return {
        ...state,
        userLogoutSuccess: false,
        isSuspendedUser: false
      };
    case SET_SUSPENDED_USER_FLAG:
      return {
        ...state,
        isSuspendedUser: payload
      };
  }
  return state;
}

export default auth;